import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';

@Component({
  selector: 'app-tag-selector',
  templateUrl: './tag-selector.component.html',
  styleUrl: './tag-selector.component.scss'
})
export class TagSelectorComponent implements OnChanges, OnInit{
  constructor(private auth: AuthServiceService, 
             private modalService: NgbModal, 
             private toastr: ToastrService, 
             private local: LocalServiceService, 
             private roleService: RoleService, 
             public activeModal: NgbActiveModal
  ){}
  ngOnInit(): void {
    this.fetchTagInfos();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(changes['productId']){
      this.fetchTagInfos();
    }
  }

  @Input()
  productId: any;

  @Input()
  selectedTagName: any;

  // JSONstringify(obj){
  //   return JSON.stringify(obj)
  // }

  public groupedTags =[]
  public visisbleGroups = []
  public closeAll(){
    this.visisbleGroups = Array(this.visisbleGroups.length);
    this.visisbleGroups.fill(false)
  }
  public newTagName = '';
  public currentGroup = null
  public groupMaps = new Map();

  
  private fetchTagInfos(){
    this.auth.getTotalTagsList(this.productId).subscribe({
      next: (data: any) =>{
        const  groupedTags = new Map()
       
        for(const tag of data.data){
          this.groupMaps[tag.parentName] = tag.parentId;

          if(groupedTags.has(tag.parentName)){
            groupedTags.get(tag.parentName).push([tag.tag, tag.parentId, tag.isAddedByMe])
          }else{
            groupedTags.set(tag.parentName, [[tag.tag, tag.parentId, tag.isAddedByMe]])
          }
         
        }

        this.visisbleGroups = Array(groupedTags.size);
        this.visisbleGroups.fill(false)
        this.groupedTags = []
        for(const key of groupedTags){
          this.groupedTags.push([key, groupedTags.get(key)])
        }
        console.log("GT", this.groupedTags)

     
      },
      error: console.error
    });
   
  }
  isAdmin = () => this.roleService?.roles?.userType.includes('ADMIN')

  public deleteTag(tagName){
    this.local.confirmYesNo({title: 'Delete Tag', text: 'Are you sure you want to delete this tag?', icon: 'wanring'}).then(
      data =>{
        if(data.isConfirmed){
          this.auth.deleteTag(tagName).subscribe({
            next: (data)=>{
              this.toastr.success("Deleted!")
              this.fetchTagInfos();
            },
            error: err =>{
              console.error(err)
              this.toastr.error("Error something went wrong while deleting")
      
      
            }
          })
        }

      }
    )

  }

  public addTagToProduct(tagName, parentId){
      this.auth.addTagToProduct(tagName,parentId, this.productId, this.isAdmin()).subscribe({
        next: (data)=>{
          this.toastr.success("Successfully Added");
          this.activeModal.close({tagName, parentTagId: parentId, added: true});
          
         


        },
        error: err =>{
          console.log(err);
          this.toastr.error("Something went wrong");
         // this.modalService.dismissAll();
        }
      })

  }


}
